/** experiment ids go here */
export const EXP_037_SAND_DELIVERY = 'exp_037_sand_delivery_p2';
export const EXP_039_ACCESSORIES_PAGE = 'exp_039_accessories_page';
export const EXP_041_ANNUAL_PRE_PURCHASE = 'exp_041_annual_pre_purchase';
